class BodyScroll {
  static disable () {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.marginRight = `${scrollbarWidth}px`;
    document.body.classList.add('body_modal-active');
  }

  static enable () {
    document.documentElement.style.marginRight = '';
    document.body.classList.remove('body_modal-active');
  }
}

export default BodyScroll;
